<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="780px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="160px" :label-position="labelPosition">
        <div class="form-flex-box">
          <el-form-item label="背景图:" prop="bgImg">
            <base-upload class="upload" :cover="params.bgImg" :action="action" :wSize="180" :hSize="90" :width="'180px'"
              :height="'90px'" @successCallback="handleAvatarSuccess"></base-upload>
          </el-form-item>
          <el-form-item label="新背景图:" prop="newBgImg">
            <base-upload class="upload" :cover="params.newBgImg" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleNewAvatarSuccess"></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="预售背景:" prop="advanceBgImgNew">
            <base-upload class="upload" :cover="params.advanceBgImgNew" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleNewPresaleSuccess"></base-upload>
          </el-form-item>
          <el-form-item label="预售背景(选中):" prop="advanceBgImg">
            <base-upload class="upload" :cover="params.advanceBgImg" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handlePresaleSuccess"></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="尾款背景:" prop="advanceBgImgFinalPayNew">
            <base-upload class="upload" :cover="params.advanceBgImgFinalPayNew" :action="action" :wSize="180"
              :hSize="90" :width="'180px'" :height="'90px'" @successCallback="handleNewFinalPaySuccess"></base-upload>
          </el-form-item>
          <el-form-item label="尾款背景(选中):" prop="advanceBgImgFinalPay">
            <base-upload class="upload" :cover="params.advanceBgImgFinalPay" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleFinalPaySuccess"></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="名称(不可重复):" prop="productName">
            <el-input v-model="params.productName" size="small"></el-input>
          </el-form-item>
          <el-form-item label="新名称:" prop="newName">
            <el-input v-model="params.newName" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="ios现价(金币):" prop="discountedPriceIos">
            <el-input v-model.number="params.discountedPriceIos" size="small"></el-input>
          </el-form-item>
          <el-form-item label="安卓现价(金币):" prop="discountedPriceAnd">
            <el-input v-model.number="params.discountedPriceAnd" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="原价(金币):" prop="originalPrice">
            <el-input v-model.number="params.originalPrice" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送众筹免费次数:" prop="crowdfundFreeCount">
            <el-input v-model.number="params.crowdfundFreeCount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品类型:" prop="productType">
            <el-select v-model="params.productType" size="small" clearable placeholder="请选择产品类型">
              <el-option v-for="item in productTypeList" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="持续时间(天):" prop="duration">
            <el-input v-model.number="params.duration" size="small"></el-input>
          </el-form-item>
        </div>
        <div v-if="params.productType === 9" class="form-flex-box">
          <el-form-item label="可领楼凤(次/周):" prop="timesAWeek">
            <el-input v-model.number="params.timesAWeek" size="small"></el-input>
          </el-form-item>
        </div>
        <div v-if="params.productType === 0 || params.productType === 5" class="form-flex-box">
          <el-form-item label="赠送观影券金币:" prop="goldVideoCouponNum">
            <el-input v-model.number="params.goldVideoCouponNum" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送观影券数量:" prop="goldVideoCouponCount">
            <el-input v-model.number="params.goldVideoCouponCount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="params.productType === 21">
          <el-form-item label="预付金额:">
            <el-input v-model.number="params.advanceAmount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="尾款金额:">
            <el-input v-model.number="params.balanceAmount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="params.productType === 21">
          <el-form-item label="支付尾款开始时间:" prop="startTime">
            <el-date-picker type="datetime" v-model="params.startTime" placeholder="选择日期时间"
              size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="支付尾款结束时间:" prop="endTime">
            <el-date-picker type="datetime" v-model="params.endTime" placeholder="选择日期时间" size="small"></el-date-picker>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="params.productType === 21">
          <el-form-item label="活动时间:" prop="activityTime">
            <el-date-picker type="datetime" v-model="params.activityTime" placeholder="选择日期时间"
              size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="免费抽奖次数:">
            <el-input v-model.number="params.drawsCount" size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item label="所有金币视频免费:">
            <el-switch v-model="params.allGoldVideoFree"></el-switch>
          </el-form-item> -->
        </div>
        <div class="form-flex-box" v-if="params.productType == 21">
          <el-form-item label="是否首页弹窗:">
            <el-switch v-model="params.isHomePopUp"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="楼凤折扣率(%):" prop="louFengDiscount">
            <el-input v-model.number="params.louFengDiscount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="专属特惠:" prop="exclusiveOffer">
            <el-input v-model="params.exclusiveOffer" size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务时间(单位:分钟):" prop="serviceTime" v-if="params.productType === 12">
            <el-input v-model.number="params.serviceTime" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="楼凤预约折扣率(%):">
            <el-input v-model.number="params.loufengBookDiscount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤预约折扣时间:">
            <el-input v-model.number="params.loufengBookDiscountDays" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="展示单价:">
            <el-switch v-model="params.unitPriceDisplay"></el-switch>
          </el-form-item>
          <el-form-item label="上架:">
            <el-switch v-model="params.status"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品位置:" prop="position">
            <el-select v-model="params.position" size="small" clearable placeholder="请选择产品位置">
              <el-option v-for="item in positionTypeList" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用金币购买:">
            <el-switch v-model="params.isAmountPay"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="私信价格:" prop="chatPrice">
            <el-input v-model.number="params.chatPrice" size="small" placeholder="设置负数为免费"></el-input>
          </el-form-item>
          <el-form-item label="打卡天数:" prop="signDays" v-if="params.productType === 24">
            <el-input v-model.number="params.signDays" size="small"></el-input>
          </el-form-item>
          <el-form-item v-else></el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="直播有效天数">
            <el-input v-model.number="params.broadcastDays" size="small" placeholder="请输入直播有效天数"></el-input>
          </el-form-item>
          <el-form-item label="所有金币视频免费:">
            <el-switch v-model="params.allGoldVideoFree"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="金币视频免费天数:" prop="goldVideoFreeDay">
            <el-input v-model.number="params.goldVideoFreeDay" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.number="params.sort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送游戏金币数量:" prop="giveGameCoin">
            <el-input v-model.number="params.giveGameCoin" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤解锁次数:" prop="louFengUnlockTimes">
            <el-input v-model.number="params.louFengUnlockTimes" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送金币数量:" prop="giveCoin">
            <el-input v-model.number="params.giveCoin" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送ai脱衣次数:" prop="aiUndressCount">
            <el-input v-model.number="params.aiUndressCount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送下载次数:" prop="downloadCount">
            <el-input v-model.number="params.downloadCount" size="small"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <template v-if="params.productType === 21">
          <div class="form-flex-box">
            <el-form-item label="每日ai脱衣次数限制:" prop="aiUndressLimitPerDay">
              <el-input v-model.number="params.prepaidPrivilege.aiUndressLimitPerDay" size="small"></el-input>
            </el-form-item>
            <el-form-item label="每日金币视频免费次数:" prop="coinVideoLimitPerDay">
              <el-input v-model.number="params.prepaidPrivilege.coinVideoLimitPerDay" size="small"></el-input>
            </el-form-item>
          </div>
          <div class="form-flex-box">
            <el-form-item label="每日下载次数限制:" prop="downloadLimitPerDay">
              <el-input v-model.number="params.prepaidPrivilege.downloadLimitPerDay" size="small"></el-input>
            </el-form-item>
            <el-form-item label="每日抽奖次数限制:" prop="luckyDrawLimitPerDay">
              <el-input v-model.number="params.prepaidPrivilege.luckyDrawLimitPerDay" size="small"></el-input>
            </el-form-item>
          </div>
        </template>
        <div class="form-flex-box">
          <el-form-item label="会员等级:" prop="vipLevel" v-if="
            this.params.productType === 0 ||
            this.params.productType == 5 ||
            this.params.productType == 21 ||
            this.params.productType == 24
          ">
            <el-select v-model="params.vipLevel" size="small" clearable placeholder="请选择会员等级">
              <el-option v-for="item in vipLevelTypeList" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新手卡倒计时:" prop="showCountdownTime" v-if="this.params.productType == 5">
            <el-input v-model.number="params.showCountdownTime" size="small" placeholder="单位：小时"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="支付视频折扣:" prop="payVidDiscount">
            <el-select v-model="params.payVidDiscount" size="small" clearable placeholder="请选择支付视频折扣">
              <el-option :value="0" label="0" key="0"></el-option>
              <el-option :value="1" label="1" key="1"></el-option>
              <el-option :value="2" label="2" key="2"></el-option>
              <el-option :value="3" label="3" key="3"></el-option>
              <el-option :value="4" label="4" key="4"></el-option>
              <el-option :value="5" label="5" key="5"></el-option>
              <el-option :value="6" label="6" key="6"></el-option>
              <el-option :value="7" label="7" key="7"></el-option>
              <el-option :value="8" label="8" key="8"></el-option>
              <el-option :value="9" label="9" key="9"></el-option>
              <el-option :value="10" label="10" key="10"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="params.productType === 13" label="金币视频折扣:" prop="videoDiscount">
            <el-select v-model="params.videoDiscount" size="small" clearable placeholder="请选择金币视频折扣率">
              <el-option :value="1" label="1" key="1"></el-option>
              <el-option :value="2" label="2" key="2"></el-option>
              <el-option :value="3" label="3" key="3"></el-option>
              <el-option :value="4" label="4" key="4"></el-option>
              <el-option :value="5" label="5" key="5"></el-option>
              <el-option :value="6" label="6" key="6"></el-option>
              <el-option :value="7" label="7" key="7"></el-option>
              <el-option :value="8" label="8" key="8"></el-option>
              <el-option :value="9" label="9" key="9"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="渠道分成模式:" prop="chanSplitMod">
            <el-select v-model="params.chanSplitMod" placeholder="请选择渠道分成模式" class="privileges">
              <el-option v-for="item in chanSplitMods" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box" style="width: 300px">
          <el-form-item label="特权:" prop="privilege">
            <el-select v-model="params.privilege" multiple placeholder="请选择特权" class="privileges">
              <el-option v-for="item in productAllList" :key="item.id" :label="item.privilegeName"
                :value="item.privilege">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="备注:" prop="desc">
          <el-input type="textarea" v-model="params.desc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="特权描述:" prop="privilegeDesc">
          <el-input type="textarea" v-model="params.privilegeDesc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="活动描述:" prop="actionDesc">
          <el-input type="textarea" v-model="params.actionDesc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="vip卡描述:" prop="vipCardDesc">
          <el-input type="textarea" v-model="params.vipCardDesc" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import { validatorIndex } from "@/utils/validator";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      productAllList: [],
      products: [
        { label: "铂金卡(月度会员)", value: 1 },
        { label: "钻石卡(季度会员)", value: 2 },
        { label: "至尊卡(年度会员)", value: 3 },
      ],
      productTypeList: [
        { label: "会员卡", value: 0 },
        { label: "约会卡", value: 3 },
        { label: "新手卡", value: 5 },
        { label: "实体商品", value: 6 },
        { label: "楼凤优惠卡", value: 9 },
        { label: "楼凤全免卡", value: 10 },
        { label: "其它卡", value: 20 },
        { label: "裸聊服务", value: 12 },
        { label: "视频折扣卡", value: 13 },
        { label: "视频免费卡", value: 14 },
        { label: "预售卡", value: 21 },
        { label: "白嫖卡", value: 24 },
        { label: "特权卡", value: 30 },
      ],
      vipLevelTypeList: [
        { label: "VIP", value: 1 },
        { label: "超级VIP", value: 2 },
        { label: "暗网会员", value: 3 },
      ],
      positionTypeList: [],
      privileges: [
        { label: "评论回复", value: 1 },
        { label: "专属客服", value: 2 },
        { label: "专属线路", value: 3 },
        { label: "头像昵称", value: 4 },
        { label: "离线缓存", value: 5 },
        { label: "至尊会员", value: 6 },
        { label: "金币特权", value: 7 },
        { label: "专属特权", value: 8 },
        { label: "防封特权", value: 9 },
        { label: "评论免审", value: 10 },
        { label: "至尊VIP", value: 11 },
        { label: "至尊金币", value: 12 },
        { label: "至尊特权", value: 13 },
        { label: "至尊缓存", value: 14 },
        { label: "帝王VIP", value: 15 },
        { label: "帝王金币", value: 16 },
        { label: "帝王无敌", value: 17 },
        { label: "帝王缓存", value: 18 },
        { label: "帝王特权", value: 19 },
        { label: "帝王暗网", value: 20 },
        { label: "外围约炮", value: 21 },
        { label: "女神裸聊", value: 22 },
        { label: "下载缓存", value: 23 },
        { label: "下载缓存", value: 24 },
      ],
      chanSplitMods: [
        { label: "不分成", value: 0 },
        { label: "正常分成", value: 1 },
      ],
      params: {
        crowdfundFreeCount: 0,
        productName: "",
        newName: "",
        desc: "",
        duration: "",
        originalPrice: "",
        discountedPrice: "",
        sort: "",
        vipLevel: "",
        bgImg: "",
        newBgImg: "",
        advanceBgImg: "",
        advanceBgImgNew: "",
        advanceBgImgFinalPay: "",
        advanceBgImgFinalPayNew: "",
        status: false,
        unitPriceDisplay: false,
        productType: "",
        goldVideoCouponNum: undefined,
        goldVideoCouponCount: undefined,
        loufengBookDiscount: 0,
        loufengBookDiscountDays: 0,
        isHomePopUp: false,
        advanceAmount: 0,
        balanceAmount: 0,
        startTime: "",
        endTime: "",
        activityTime: "",
        allGoldVideoFree: false,
        position: "",
        actionDesc: "",
        vipCardDesc: "",
        privilegeDesc: "",
        showCountdownTime: 24,
        isAmountPay: false,
        giveCoin: "",
        aiUndressCount: "",
        downloadCount: "",
        giveGameCoin: "",
        louFengUnlockTimes: "",
        goldVideoFreeDay: "",
        chatPrice: 0,
        signDays: 0,
        serviceTime: "",
        chanSplitMod: 0,
        payVidDiscount: undefined,
        videoDiscount: undefined,
        broadcastDays: null,
        drawsCount: 0,
        prepaidPrivilege: {
          aiUndressLimitPerDay: 0,
          coinVideoLimitPerDay: 0,
          downloadLimitPerDay: 0,
          luckyDrawLimitPerDay: 0,
        },
      },
      rules: {
        productName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        newName: [{ required: true, message: "请输入新名称", trigger: "blur" }],
        duration: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        originalPrice: [
          { required: true, message: "请输入原价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        discountedPriceIos: [
          { required: true, message: "请输入IOS现价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        discountedPriceAnd: [
          { required: true, message: "请输入安卓现价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        goldVideoFreeDay: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        position: [
          { required: true, message: "请选择产品位置", trigger: "blur" },
        ],
        timesAWeek: [
          { required: true, message: "请输入每周可领次数", trigger: "blur" },
        ],
        louFengDiscount: [
          { required: true, message: "请输入楼凤折扣率", trigger: "blur" },
        ],
        serviceTime: [
          { required: true, message: "请输入服务时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //获取产品位置
    getNames() {
      this.loading = true;
      API.getNames(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.positionTypeList = res.data.list.map((item, index) => {
              let positionObj = {};
              positionObj.key = index;
              positionObj.value = item;
              return positionObj;
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        productName: "",
        newName: "",
        desc: "",
        duration: "",
        originalPrice: "",
        discountedPrice: "",
        sort: 0,
        status: false,
        unitPriceDisplay: false,
        vipLevel: "",
        bgImg: "",
        newBgImg: "",
        advanceBgImg: "",
        advanceBgImgNew: "",
        advanceBgImgFinalPay: "",
        advanceBgImgFinalPayNew: "",
        position: "",
        actionDesc: "",
        vipCardDesc: "",
        privilegeDesc: "",
        showCountdownTime: "",
        isAmountPay: "",
        exclusiveOffer: "",
        productType: "",
        timesAWeek: undefined,
        louFengDiscount: undefined,
        loufengBookDiscount: 0,
        loufengBookDiscountDays: 0,
        isHomePopUp: false,
        advanceAmount: 0,
        balanceAmount: 0,
        signDays: 0,
        startTime: "",
        endTime: "",
        activityTime: "",
        allGoldVideoFree: false,
        giveCoin: "",
        aiUndressCount: "",
        downloadCount: "",
        payVidDiscount: undefined,
        videoDiscount: undefined,
        goldVideoCouponCount: undefined,
        goldVideoCouponNum: undefined,
        drawsCount: 0,
        prepaidPrivilege: {
          aiUndressLimitPerDay: 0,
          coinVideoLimitPerDay: 0,
          downloadLimitPerDay: 0,
          luckyDrawLimitPerDay: 0,
        },
      };
      try {
        this.$refs["form"].resetFields();
      } catch (error) {
      }
    },
    //获取产品位置
    getProductAllList() {
      API.getProductAllList().then((res) => {
        if (res.code === 200) {
          this.productAllList = res.data || [];
        }
      });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.getNames();
      this.getProductAllList();
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑VIP商品";
        this.params = { ...data };
        this.id = data.id;
        if (this.params.payVidDiscount === 0) {
          this.params.payVidDiscount = undefined;
        }
        if (this.params.videoDiscount === 0) {
          this.params.videoDiscount = undefined;
        }
        if (!this.params.prepaidPrivilege) {
          this.params.prepaidPrivilege = {
            aiUndressLimitPerDay: 0,
            coinVideoLimitPerDay: 0,
            downloadLimitPerDay: 0,
            luckyDrawLimitPerDay: 0,
          };
        }
      } else {
        this.title = "新增VIP商品";
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.bgImg = res.data.coverImg;
    },
    // 标签封面上传成功回掉新
    handleNewAvatarSuccess(res) {
      this.params.newBgImg = res.data.coverImg;
    },
    handlePresaleSuccess(res) {
      this.params.advanceBgImg = res.data.coverImg;
    },
    handleNewPresaleSuccess(res) {
      this.params.advanceBgImgNew = res.data.coverImg;
    },
    handleFinalPaySuccess(res) {
      this.params.advanceBgImgFinalPay = res.data.coverImg;
    },
    handleNewFinalPaySuccess(res) {
      this.params.advanceBgImgFinalPayNew = res.data.coverImg;
    },

    // 新增商品
    addProduct() {
      let params = this.params;
      if (params.productType === 0) {
        if (
          (!params.goldVideoCouponCount && params.goldVideoCouponNum) ||
          (params.goldVideoCouponCount && !params.goldVideoCouponNum)
        ) {
          this.$message.error("赠送金币券与数量不可单独配置!");
          this.flag = false;
          return;
        }
      }
      if (
        (params.loufengBookDiscount || params.loufengBookDiscountDays) &&
        !(params.loufengBookDiscount && params.loufengBookDiscountDays)
      ) {
        this.$message.error(
          "楼凤预约折扣与楼凤预约折扣时间要么都是空，要么都有值!!!"
        );
        this.flag = false;
        return;
      }
      // if (params.chatPrice < 0) {
      //   this.$message.error("私信价格必须大于等于0");
      //   this.flag = false;
      //   return;
      // }
      API.getNewSection(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑商品
    editProduct() {
      // if (this.params.chatPrice < 0) {
      //   this.$message.error("私信价格必须大于等于0");
      //   this.flag = false;
      //   return;
      // }
      let form = Object.assign(this.params, {
        id: this.id,
        actionDesc: this.params.actionDesc
          ? this.params.actionDesc
          : "ZERO_VALUE",
        privilegeDesc: this.params.privilegeDesc
          ? this.params.privilegeDesc
          : "ZERO_VALUE",
      });
      if (form.productType === 0) {
        if (
          (!form.goldVideoCouponCount && form.goldVideoCouponNum) ||
          (form.goldVideoCouponCount && !form.goldVideoCouponNum)
        ) {
          this.$message.error("赠送金币券与数量不可单独配置!");
          this.flag = false;
          return;
        }
      }
      if (
        (this.params.loufengBookDiscount ||
          this.params.loufengBookDiscountDays) &&
        !(
          this.params.loufengBookDiscount && this.params.loufengBookDiscountDays
        )
      ) {
        this.$message.error(
          "楼凤预约折扣与楼凤预约折扣时间要么都是空，要么都有值!"
        );
        this.flag = false;
        return;
      }
      API.getEditSection(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 150px;
  }

  .flex-item {
    width: 90%;
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }

    .item-box {
      display: flex;
      flex-direction: column;
    }
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .privileges .el-input--suffix {
    width: 480px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
